export const BASE_COLOR_THEMES = [
  {
    id: 'aurora',
    label: 'Aurora',
    palette: ['#8639A1', '#3F8EFC', '#82CA9D', '#FFC658', '#FF7F50', '#8DD1E1'],
  },
  {
    id: 'midnight',
    label: 'Midnight',
    palette: ['#0D253F', '#1B3A57', '#34699A', '#4DACFF', '#9ED0FF', '#C5E5FF'],
  },
  {
    id: 'sunset',
    label: 'Sunset',
    palette: ['#F96332', '#FB8C00', '#FDD835', '#F2C94C', '#F2994A', '#EB5757'],
  },
  {
    id: 'verdant',
    label: 'Verdant',
    palette: ['#0F766E', '#1ABC9C', '#2ECC71', '#6FCF97', '#A3E635', '#C1F4C5'],
  },
  {
    id: 'blossom',
    label: 'Blossom',
    palette: ['#8E44AD', '#C74BBD', '#F06292', '#F8BBD0', '#B39DDB', '#9575CD'],
  },
];

export const DEFAULT_THEME_ID = BASE_COLOR_THEMES[0].id;

export const sanitizeHexColor = (value) => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/.test(trimmed)) {
    return trimmed.toUpperCase();
  }
  if (/^[0-9A-Fa-f]{6}$/.test(trimmed)) {
    return `#${trimmed.toUpperCase()}`;
  }
  return null;
};

export const normalizePalette = (palette = []) => {
  if (!Array.isArray(palette)) return [];
  const cleaned = [];
  palette.forEach((color) => {
    const sanitized = sanitizeHexColor(color);
    if (sanitized) cleaned.push(sanitized);
  });
  return cleaned;
};

export const getThemeById = (id, themes) => {
  const source = Array.isArray(themes) && themes.length ? themes : BASE_COLOR_THEMES;
  if (typeof id === 'string') {
    const trimmed = id.trim();
    if (trimmed) {
      const found = source.find((theme) => theme.id === trimmed);
      if (found) return found;
    }
  }
  return source[0] || BASE_COLOR_THEMES[0];
};

export const mergeThemeLists = (customThemes = []) => {
  const merged = [...BASE_COLOR_THEMES];
  const seen = new Set(merged.map((theme) => theme.id));
  (Array.isArray(customThemes) ? customThemes : []).forEach((theme) => {
    if (!theme || typeof theme !== 'object') return;
    const id = typeof theme.id === 'string' ? theme.id.trim() : '';
    const label = typeof theme.label === 'string' ? theme.label.trim() : '';
    const palette = normalizePalette(theme.palette);
    if (!id || !label || palette.length === 0) return;
    if (seen.has(id)) {
      const idx = merged.findIndex((t) => t.id === id);
      if (idx >= 0) merged[idx] = { id, label, palette };
    } else {
      merged.push({ id, label, palette });
      seen.add(id);
    }
  });
  return merged;
};
